import { createContext } from 'react';

import { InternalBackupDashboardRecord } from '@totem/components/services/backup/internalDashboard/types';

interface Context {
  loading: boolean;
  data: InternalBackupDashboardRecord[];
}

const defaultValue: Context = {
  loading: true,
  data: [],
};

const InternalBackupDashboardContext = createContext<Context>(defaultValue);

export default InternalBackupDashboardContext;
